import { createContext } from "react";

import type { Impulse } from "~/tools/impulse";
import { useRequiredContext } from "~/tools/use-required-context";

const ToggleListRootContext = createContext<null | Impulse<string>>(null);

export const ToggleListRootContextProvider = ToggleListRootContext.Provider;

export const useToggleListNamespace = (): Impulse<string> =>
	useRequiredContext(ToggleListRootContext, {
		providerName: "ToggleList.Root",
	});
